var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionDrag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4127 20H0.0126953V15H2.4127V20ZM9.6127 20H7.2127V15H9.6127V20ZM16.8127 20H14.4127V15H16.8127V20ZM24.0127 20H21.6127V15H24.0127V20ZM2.4127 12.5H0.0126953V7.5H2.4127V12.5ZM9.6127 12.5H7.2127V7.5H9.6127V12.5ZM16.8127 12.5H14.4127V7.5H16.8127V12.5ZM24.0127 12.5H21.6127V7.5H24.0127V12.5ZM2.4127 5H0.0126953V0H2.4127V5ZM9.6127 5H7.2127V0H9.6127V5ZM16.8127 5H14.4127V0H16.8127V5ZM24.0127 5H21.6127V0H24.0127V5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDrag);
export default __webpack_public_path__ + "static/media/question-drag.e84afe46d3c44c593a8ca27abfd5513f.svg";
export { ForwardRef as ReactComponent };